module.exports = __webpack_public_path__ + "media/packs/images/dropdown-arrow-c09f6378ea2cbd09ffb83d27e02a6f38.svg";